import type { ImgHTMLAttributes, SVGProps } from 'react'

export function LightningBoltIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path d='M13.5 2.25 5.8 13.05c-.35.49 0 1.2.6 1.2h5.35l-1.35 7.5 7.7-10.8c.35-.49 0-1.2-.6-1.2h-5.35l1.35-7.5Z' fill='currentColor' />
		</svg>
	)
}

/** Empty search results — slot machine with X reels (visual reference only; not an imported SVG asset). */
export function SearchEmptyIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path d='M30 28c0-8.284 6.716-15 15-15h30c8.284 0 15 6.716 15 15v8H30v-8Z' fill='currentColor' className='opacity-40' />
			<path d='M28 36h64a6 6 0 0 1 6 6v52a8 8 0 0 1-8 8H30a8 8 0 0 1-8-8V42a6 6 0 0 1 6-6Z' fill='currentColor' className='opacity-55' />
			<path d='M36 48h48a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H36a4 4 0 0 1-4-4V52a4 4 0 0 1 4-4Z' fill='currentColor' className='opacity-25' />
			<path d='M42 48h10v44H42V48Zm18 0h10v44H60V48Zm18 0h10v44H78V48Z' fill='currentColor' className='opacity-35' />
			<path d='M47 64l6 6m0-6-6 6M65 64l6 6m0-6-6 6M83 64l6 6m0-6-6 6' stroke='currentColor' strokeWidth='3.5' strokeLinecap='round' className='opacity-80' />
			<path d='M52 22h16a6 6 0 0 1 0 12H52a6 6 0 0 1 0-12Z' fill='currentColor' className='opacity-45' />
			<path d='M57 28h6M54 28h1.5M64.5 28H66' stroke='currentColor' strokeWidth='2' strokeLinecap='round' className='opacity-70' />
			<path d='M59 25.5 63 29.5m0-4-4 4' stroke='currentColor' strokeWidth='2' strokeLinecap='round' className='opacity-80' />
			<path d='M98 48c2.2 0 4 1.8 4 4v6h2.5a3.5 3.5 0 0 1 0 7H102v18' stroke='currentColor' strokeWidth='4' strokeLinecap='round' className='opacity-50' />
			<circle cx='102' cy='40' r='5' fill='currentColor' className='opacity-60' />
			<path d='M38 96h14a2 2 0 0 1 2 2v2H36v-2a2 2 0 0 1 2-2Z' fill='currentColor' className='opacity-40' />
			<circle cx='78' cy='99' r='3.5' fill='currentColor' className='opacity-45' />
		</svg>
	)
}

export function RandomDiceIcon({ className, ...props }: Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>) {
	return <img src='/images/casino/random-dice.png' alt='' aria-hidden className={className} draggable={false} {...props} />
}
